// extracted by mini-css-extract-plugin
export default {"desktop":"1200px","tablet":"700px","tabletLandscape":"900px","blueColor":"#3271ab","darkGreyColor":"#5c5c5c"};